import React, { useEffect, useState } from "react";
import { useAppDispatch } from "../../../redux/hooks";

import ContentCard from "../../../components/misc/ContentCard";
import CustomButton from "../../../components/CustomButton";
import CollectionErrorsDetailed from "./CollectionErrorsDetailed";
import {
  clearCollectionErrorsDetailed,
  clearCollectionErrorsSimplified,
} from "../../../redux/reducer/reports.reducer";
import CollectionErrorsSimplified from "./CollectionErrrorsSimplified";

function CollectionErrors() {
  const dispatch = useAppDispatch();

  const [selectedType, setSelectedType] = useState<"simplified" | "detailed">(
    "simplified",
  );

  useEffect(() => {
    return () => {
      dispatch(clearCollectionErrorsSimplified());
      dispatch(clearCollectionErrorsDetailed());
    };
  }, [dispatch]);

  return (
    <>
      <ContentCard cardBodyClassName="d-flex">
        <CustomButton
          variant={selectedType === "simplified" ? "contained" : "outlined"}
          style={{ borderEndEndRadius: 0, borderStartEndRadius: 0 }}
          fullWidth
          onClick={() => setSelectedType("simplified")}>
          Raport simplificat
        </CustomButton>
        <CustomButton
          variant={selectedType === "detailed" ? "contained" : "outlined"}
          style={{ borderEndStartRadius: 0, borderStartStartRadius: 0 }}
          fullWidth
          onClick={() => setSelectedType("detailed")}>
          Raport detaliat
        </CustomButton>
      </ContentCard>
      {selectedType === "simplified" && <CollectionErrorsSimplified />}

      {selectedType === "detailed" && <CollectionErrorsDetailed />}
    </>
  );
}

export default CollectionErrors;
